import { Species } from "../../api/dtos/dtos";


export class SpeciesTypes {
    static readonly WILDDOG = new SpeciesTypes(Species.WildDog, "WILDDOG", "wilddogscan");
    static readonly DEER = new SpeciesTypes(Species.Deer, "DEER", "deerscan");
    static readonly RABBIT = new SpeciesTypes(Species.Rabbit, "RABBIT", "rabbitscan");
    static readonly FERALCAT = new SpeciesTypes(Species.FeralCat, "FERALCAT", "feralcatscan");
    static readonly FOX = new SpeciesTypes(Species.Fox, "FOX", "foxscan");
    static readonly FERALPIG = new SpeciesTypes(Species.FeralPig, "FERALPIG", "feralpigscan");
    static readonly MYNA = new SpeciesTypes(Species.Myna, "MYNA", "mynascan");
    static readonly TOAD = new SpeciesTypes(Species.Toad, "TOAD", "toadscan");
    static readonly MOUSE = new SpeciesTypes(Species.Mouse, "MOUSE", "mousealert");
    static readonly FERALGOAT = new SpeciesTypes(Species.FeralGoat, "FERALGOAT", "feralgoatscan");
    static readonly FERALFISH = new SpeciesTypes(Species.FeralFish, "FERALFISH", "feralfishscan");
    static readonly STARLING = new SpeciesTypes(Species.Starling, "STARLING", "starlingscan");
    static readonly OTHERPESTS = new SpeciesTypes(Species.OtherPests, "OTHERPESTS", "otherpests");
    static readonly NEWPESTS = new SpeciesTypes(Species.NewPests, "NEWPESTS", "newpests");

    private constructor(private readonly species: Species, private readonly name: string, public readonly path: string) {}

    static toArray(): string[] {
        return [
            this.WILDDOG.path,
            this.DEER.path,
            this.RABBIT.path,
            this.FERALCAT.path,
            this.FOX.path,
            this.FERALPIG.path,
            this.MYNA.path,
            this.TOAD.path,
            this.MOUSE.path,
            this.FERALGOAT.path,
            this.FERALFISH.path,
            this.STARLING.path,
            this.OTHERPESTS.path,
            this.NEWPESTS.path,
        ]
    }

    toSpecies(): Species {
        return this.species;
    }

    toString(): string {
        return this.name;
    }
}

export const SpeciesHeatmapConfiguration: Record<number, { maxIntensity: number, radius: number, zoomCutoff: number }> = {
    1: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    2: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    3: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    4: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    5: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    6: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    7: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    8: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    9: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    10: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    11: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    12: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    13: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    14: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    15: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    16: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    17: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    },
    18: {
        maxIntensity: 300,
        radius: 20,
        zoomCutoff: 6
    }
};